import React, { useState, useEffect } from 'react';
import Icon from '../../Components/Icons/Icon';
import { useAssistantContext } from '../../Components/Assistant';
import { Link } from 'react-router-dom';
import Switcher from '../Switcher';
import { useSession } from '../../Components/Session';
import GlobalSearch from '../../Components/GlobalSearch';
import { levels } from '../../Data/Admin';


const NavRedesign = () => {
    const [switcherOpen, setSwitcherOpen] = useState(false);
    const [globalSearchOpen, setGlobalSearchOpen] = useState(false);
    const { notificationBadge, isAdmin, isAdminSwitched, adminSwitchBack } = useSession();

    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                setGlobalSearchOpen(true);
            }
            if ((e.metaKey || e.ctrlKey) && e.key === 'j') {
                e.preventDefault();
                setSwitcherOpen(true);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <div className="grow-0 pt-2 pr-2 max-h-screen min-h-screen print:hidden dark:text-slate-100 dark:fill-slate-100">
            <nav className="mt-1 fixed mx-auto h-full overflow-y-auto no-scrollbar">
                <div className="flex flex-col gap-3 p-4">
                    <Link to="/" className="flex items-center gap-3 p-3 cursor-pointer transition-all hover:bg-white dark:hover:bg-slate-800 rounded-full w-full">
                        <Icon icon="HouseChimney" size="2x" badge={notificationBadge} />
                        <span className="font-medium">Home</span>
                    </Link>

                    <div className="flex items-center gap-3 p-3 cursor-pointer transition-all hover:bg-white dark:hover:bg-slate-800 rounded-full w-full"
                        onClick={() => setGlobalSearchOpen(true)}
                    >
                        <Icon icon="MagnifyingGlass" size="2x" />
                        <span className="font-medium">Search</span>
                        <KeyboardShortcut shortcut="Ctrl+K" />
                    </div>

                    <div className="flex items-center gap-3 p-3 cursor-pointer transition-all hover:bg-white dark:hover:bg-slate-800 rounded-full w-full"
                        onClick={() => setSwitcherOpen(!switcherOpen)}
                    >
                        <Icon icon="GridRound2" size="2x" />
                        <span className="font-medium">Menu</span>
                        <KeyboardShortcut shortcut="Ctrl+J" />
                    </div>

                    {isAdmin(levels.READ_ONLY) && <Link to="/admin" className="flex items-center gap-3 p-3 cursor-pointer transition-all hover:bg-white dark:hover:bg-slate-800 rounded-full w-full">
                        <Icon icon="Wrench" size="2x" />
                        <span className="font-medium">Admin</span>
                    </Link>}

                    {isAdminSwitched && <div className="flex items-center gap-3 p-3 cursor-pointer transition-all text-red-600 fill-red-600 hover:bg-white dark:hover:bg-slate-800 rounded-full w-full"
                        onClick={() => adminSwitchBack()}
                    >
                        <Icon icon="ArrowLeftToBracket" size="2x" />
                        <span className="font-bold">Switch back</span>
                    </div>}

                    <div className="mt-auto">
                        <Assistant />
                    </div>
                </div>
            </nav>

            <div className="w-[200px]">&nbsp;</div>

            <Switcher isOpen={switcherOpen} setIsOpen={() => setSwitcherOpen(false)} />
            <GlobalSearch isOpen={globalSearchOpen} setIsOpen={() => setGlobalSearchOpen(false)} />
        </div>
    );
};

const Assistant = () => {
    const { assistantOpen, setAssistantOpen, unseen } = useAssistantContext();
    const {showDarkMode} = useSession();

    return (
        <div
            className="flex items-center gap-3 p-3 cursor-pointer transition-all hover:bg-white dark:hover:bg-slate-800 rounded-full w-full"
            onClick={() => setAssistantOpen(!assistantOpen)}
        >
            <Icon
                icon={
                    assistantOpen || unseen ? (showDarkMode ? "SidSolidDark" : "SidSolid") : (showDarkMode ? "SidLightDark" : "SidLight")
                }
                theme="soapy"
                size="2x"
                badge={unseen}
            />
            <span className="font-medium">Sid</span>
        </div>
    );
};

const KeyboardShortcut = ({ shortcut }) => {
    const isMac = () => {
        if (navigator.userAgentData) {
            return navigator.userAgentData.platform === 'macOS';
        }
        return /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
    };

    return (
        <span className="text-muted">
            ({isMac() ? shortcut.replace('Ctrl', '⌘') : shortcut})
        </span>
    );
};

export default NavRedesign;
